import React, { memo, useEffect, useRef, useState } from 'react';
import * as echarts from 'echarts';
import ReactECharts from 'echarts-for-react';

import * as _ from 'lodash';
import { log } from 'utils';

const appUrl = `${process.env.REACT_APP_ALGO_API_URL}`;

function usePrevious(value) {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  return ref.current;
}

function ChartStockOverview(props) {
  const abortController = new AbortController();

  const DEFAULT_OPTION = {
    grid: { top: 8, right: 28, bottom: 20, left: 10 },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: [],
    //   splitNumber: 20,
      minInterval: 3600 * 1000,
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dashed',
          color: '#4E4D62',
          dashOffset: 10,
          opacity: 0.3,
        },
      },
      axisTick: {
        alignWithLabel: true,
        length: 3,
      },
      axisLabel: {
        color: '#83817C',
        fontSize: 8,
        formatter: function (value, index) {
          const arr = value.split(':');
          return arr[0] + ':' + arr[1];
        },
        // width: 100,
        // overflow: 'truncate',
        // interval: 60,
        borderColor: '#ECECEC',
        showMinLabel: true,
        showMaxLabel: true,
      },
    },
    yAxis: {
      type: 'value',
      show: true,
      position: 'right',
      alignTicks: true,
      splitNumber: 4,
      //   axisLine: {
      //     show: true,
      //     lineStyle: {
      //         type: 'dashed',
      //         color: '#4E4D62'
      //     }
      //   },
      splitLine: {
        // show: false,
        lineStyle: {
          type: 'dashed',
          color: '#4E4D62',
          dashOffset: 10,
          opacity: 0.3,
        },
      },
      axisLabel: {
        color: '#83817C',
        fontSize: 8,
        showMinLabel: false,
        showMaxLabel: false,
      },
    },
    series: [
      {
        type: 'line',
        smooth: true,
        symbol: 'none',
        sampling: 'lttb',
        itemStyle: {
          color: '#03CAA6',
        },
        lineStyle: {
          width: 1,
        },
        markLine: {
          symbol: ['none', 'none'],
          label: { show: false },
          lineStyle: {
            type: 'dashed',
            color: '#BEB8B8',
            dashOffset: 10,
            opacity: 0.5,
          },
          data: [{ yAxis: 1 }],
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: '#20CA78',
            },
            {
              offset: 1,
              color: 'rgba(61, 176, 85, 0)',
            },
          ]),
        },
        data: [],
      },
    ],
    tooltip: false,
  };

  const [option, setOption] = useState(DEFAULT_OPTION);

  const { symActive, stockRealShow } = props
  const preStockRealShow = usePrevious(stockRealShow);

  useEffect(() => {
    return () => {
      abortController.abort();
    };
  }, []);

  useEffect(() => {
    if(symActive) _handleLoadDataStock();
  }, [symActive]);

  useEffect(() => {
    if(stockRealShow && !_.isEqual(stockRealShow, preStockRealShow))
      processRealtime(stockRealShow)
  }, [stockRealShow]);

  function _handleLoadDataStock() {
    // log(symActive, appUrl);
    if (!symActive) return;

    fetch(
      appUrl + 'pbapi/api/stockBoard/chart/stock/' + symActive,
      {
        signal: abortController.signal,
      }
    )
      .then((response) => response.json())
      .then((res) => {
        // // log(res);
        if(res.status === 200)
        _mapDataToState(res.data);
      })
      .catch((error) => {
        log(error);
      });
  }

  function _mapDataToState(dt) {
    if (!dt.length) return;

    const newOption = _.cloneDeep(option);

    const yAxis = _.map(dt, 'MatchPrice');
    const xAxis = _.map(dt, 'Time');

    const _min = _.min(yAxis);
    const _max = _.max(yAxis);

    newOption.xAxis.data = xAxis;
    newOption.yAxis.min = _min;
    newOption.yAxis.max = _max;
    newOption.series[0].data = yAxis;

    const _lastChange = dt[dt.length - 1].PriceChange;
    if (_lastChange > 0) {
      // up
      newOption.series[0].itemStyle.color = '#03CAA6';
      newOption.series[0].areaStyle.color.colorStops[0].color = '#03CAA6';
      newOption.series[0].areaStyle.color.colorStops[1].color =
        'rgba(61, 176, 85, 0)';
    } else if (_lastChange < 0) {
      // down
      newOption.series[0].itemStyle.color = '#fd1515';
      newOption.series[0].areaStyle.color.colorStops[0].color = '#fd1515';
      newOption.series[0].areaStyle.color.colorStops[1].color =
        'rgba(253, 21, 21, 0)';
    } else {
      newOption.series[0].itemStyle.color = '#F0B90B';
      newOption.series[0].areaStyle.color.colorStops[0].color = '#F0B90B';
      newOption.series[0].areaStyle.color.colorStops[1].color =
        'rgba(240, 185, 11, 0)';
    }

    // markLine
    newOption.series[0].markLine.data[0].yAxis = !!dt.length
      ? (dt[0].MatchPrice - dt[0].PriceChange)
      : 1;

    setOption(newOption);
  }

  function processRealtime(record) {
    if(_.isArray(record) && record.length > 0 && record[0] === symActive){
      const newOption = _.cloneDeep(option);
      console.log(newOption)
      let xAxis = newOption.xAxis.data;
      let yAxis = newOption.series[0].data;

      xAxis.push(record[1])
      yAxis.push(record[2])

      const _lastChange = record[3];
      if (_lastChange > 0) {
        // up
        newOption.series[0].itemStyle.color = '#03CAA6';
        newOption.series[0].areaStyle.color.colorStops[0].color = '#03CAA6';
        newOption.series[0].areaStyle.color.colorStops[1].color =
          'rgba(61, 176, 85, 0)';
      } else if (_lastChange < 0) {
        // down
        newOption.series[0].itemStyle.color = '#fd1515';
        newOption.series[0].areaStyle.color.colorStops[0].color = '#fd1515';
        newOption.series[0].areaStyle.color.colorStops[1].color =
          'rgba(253, 21, 21, 0)';
      } else {
        newOption.series[0].itemStyle.color = '#F0B90B';
        newOption.series[0].areaStyle.color.colorStops[0].color = '#F0B90B';
        newOption.series[0].areaStyle.color.colorStops[1].color =
          'rgba(240, 185, 11, 0)';
      }
      setOption(newOption);
    }
  }

  return (
    <ReactECharts
      option={option}
      style={{
        height: '100%',
        width: `100%`,
      }}
    />
  );
}

export default memo(ChartStockOverview);
